import { render, staticRenderFns } from "./AutoInfracaoRs.vue?vue&type=template&id=b0e51816&lang=pug"
import script from "./AutoInfracaoRs.vue?vue&type=script&lang=js"
export * from "./AutoInfracaoRs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports